import AppConfig from "../../config/config";

/**
 * Splits a collection name so the last word can take the accent colour.
 * A single-word name stays entirely in ink — an all-blurple title reads
 * as an error, not as emphasis.
 */
export function splitTitle(name: string): {
  head: string;
  tail: string;
  accentTail: boolean;
} {
  const words = name.trim().split(/\s+/);
  if (words.length < 2) {
    return { head: "", tail: words[0] ?? "", accentTail: false };
  }
  return {
    head: words.slice(0, -1).join(" "),
    tail: words[words.length - 1],
    accentTail: true,
  };
}

/** Formats an ISO timestamp as "DD Mon YYYY" using the app locale. */
export function formatUpdated(iso?: string | null): string | null {
  if (!iso) return null;
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return null;
  return date.toLocaleDateString(AppConfig.defaultLocale, {
    day: "numeric",
    month: "short",
    year: "numeric",
  });
}
